(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
Shopify.Products.showRecentlyViewed( {
    howManyToShow: 3,
    onComplete: () => { initSomageRecentlyViewedSlider(); }
  } );
  enableSlider();
  function initSomageRecentlyViewedSlider() {
    $('#recently-viewed-products').slick({
        centerMode: false,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        draggable: true,
        infinite: true,
        cssEase: 'linear',
        arrows: false,
        variableWidth: false,
        responsive: [
        {
            breakpoint: 768,
            settings: {
                centerMode: false,
                draggable: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
    });
    enableSlider();
  }
  function enableSlider() {
    if($('.recently-viewed-carousel').children().length == 0) {
      $('.recently-viewed-container').hide();
    } else {
      $('.recently-viewed-container').show();
    }
  }

  } catch(e) { console.error(e); }
})();

})();
